import React, { ReactNode } from 'react';
import { TourProvider, PopoverContentProps } from '@reactour/tour';
import GenericHoc from 'components/common/generic-hoc';
import { HocOptions } from 'components/common/generic-hoc.types';
import UserGuide from 'components/common/user-guide';
import { getSteps } from './constants';
import { ReduxStore } from 'reducers/redux.types';
import { Master } from 'types/master-data-types';

interface TourWrapperProps {
    master: Master;
    children: ReactNode;
    classes: Record<string, string>;
}

const styles = () => ({
    main: {
        borderRadius: '20px',
        padding: '0px !important',
    },
});

const TourWrapper: React.FC<TourWrapperProps> = ({ master, children, classes }) => {
    return (
        <TourProvider
            className={classes.main}
            steps={getSteps(master)}
            ContentComponent={UserGuide as React.ComponentType<PopoverContentProps>}
        >
            {children}
        </TourProvider>
    );
};

const mapStateToProps = (state: ReduxStore) => {
    const { master } = state;
    return {
        master,
    };
};

const hocConfig: HocOptions = {
    connectRedux: {
        useRedux: true,
        mapStateToProps,
    },
    connectJss: {
        useJss: true,
        styleSheet: styles,
    },
    connectRouter: true,
};

export default GenericHoc(hocConfig)(TourWrapper);
